// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__ZNfVA","content":"styles_content__Nk-Co","description":"styles_description__kJhuq","buttons":"styles_buttons__64qbg","button":"styles_button__3mn88"};